<template>
  <div class="index" :key="version">
    <c-toolbar type="CYBERBOARD" />
    <div class="title">{{ title }}</div>
    <div class="control-panel">
      <a-radio-group
        :value="lightIndex"
        size="large"
        @change="onLightIndexSelect"
      >
        <a-radio-button :value="4"> {{ $t("light.name") }} 1 </a-radio-button>
        <a-radio-button :value="5"> {{ $t("light.name") }} 2 </a-radio-button>
        <a-radio-button :value="6"> {{ $t("light.name") }} 3 </a-radio-button>
      </a-radio-group>
    </div>
    <div
      class="cyberboard"
      :style="{ backgroundImage: `url(${images['cyberboard_' + version]})` }"
    >
      <div
        class="light"
        @click="onLightClick"
        @mouseenter="isLightHover = true"
        @mouseleave="isLightHover = false"
      >
        <c-led-strip
          :isPlaying="true"
          :brightness="lightEffect.brightness.value"
          :speed="lightEffect.speed.value"
          :frames="lightEffect.frames"
        />
        <img class="border" :src="images.index_light_border" />
      </div>
      <div
        class="keyboard"
        @click="onKeyboardClick"
        @mouseenter="isKeyboardHover = true"
        @mouseleave="isKeyboardHover = false"
      >
        <c-keyboard
          class="c-keyboard"
          :keyboardSettings="data.keyboardSettings"
          disabled
        />
        <img class="border" :src="images.index_keyboard_border" />
      </div>
    </div>
    <div class="buttons">
      <div class="profile">{{ fileName }}</div>
      <c-profile-upload class="upload" @upload="onUpload">
        <i class="iconfont iconupload" />
        {{ $t("upload") }}
      </c-profile-upload>
      <template v-if="version === 'r2'">
        <div class="download" @click="onSave('windows')">
          <i class="iconfont icondownload" />
          {{ $t("download") }}
          <template v-if="isSignIn && false"> & {{ $t("save") }} </template>
          json
        </div>
        <c-profile-download
          ref="windows"
          profileType="windows"
          :profile="data"
          :fileName="fileName"
          :version="version"
        />
        <div class="download" @click="onSave('mac')" v-if="false">
          <i class="iconfont icondownload" />
          {{ $t("download") }}
          <template v-if="isSignIn && false"> & {{ $t("save") }} </template>
          json (mac)
        </div>
      </template>
      <div v-else class="download" @click="onSave('mac')">
        <i class="iconfont icondownload" />
        {{ $t("download") }}
        <template v-if="isSignIn && false"> & {{ $t("save") }} </template>
        json
      </div>
      <c-profile-download
        ref="mac"
        profileType="mac"
        :profile="data"
        :fileName="fileName"
        :version="version"
      />
    </div>
    <div class="in-switch-led">
      <div class="item" @click="onLightClick">
        <i class="iconfont iconarrow-right" />
        <div v-html="$t('light.name')"></div>
      </div>
      <div class="item" @click="goInSwitchLED">
        <i class="iconfont iconarrow-right" />
        <div v-html="$t('keyboard.inSwitchLED')"></div>
      </div>
      <div class="item" @click="onKeyboardClick">
        <i class="iconfont iconarrow-right" />
        <div v-html="$t('index.keyboardTitle')"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api";
export default {
  name: "Index",
  data() {
    return {
      isLightHover: false,
      isKeyboardHover: false,
      isLightScale: true,
      isKeyboardScale: false,
      isPlaying: false,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("user", {
      isSignIn: "isSignIn",
    }),
    ...mapState("profile", {
      version: "version",
      fileName: "fileName",
      data: "data",
      lightIndex: "lightIndex",
    }),
    title() {
      if (this.isLightHover) {
        return this.$t("index.lightTitle");
      } else if (this.isKeyboardHover) {
        return this.$t("index.keyboardTitle");
      } else if (this.isLightScale) {
        return this.$t("index.lightTitle");
      } else if (this.isKeyboardScale) {
        return this.$t("index.keyboardTitle");
      }
      return this.$t("index.title");
    },
    lightEffect() {
      const lightEffects = this.data.lightEffects;
      return lightEffects[this.lightIndex];
    },
    brightness() {
      return this.lightEffect.brightness.value;
    },
    speed() {
      return this.lightEffect.speed.value;
    },
    frames() {
      return this.lightEffect.frames;
    },
  },
  methods: {
    onLightIndexSelect(e) {
      this.$store.dispatch("profile/setLightIndex", e.target.value);
    },
    onLightClick() {
      this.$router.push(this.$paths.light);
    },
    onKeyboardClick() {
      this.$router.push(this.$paths.keyboard);
    },
    goInSwitchLED() {
      this.$router.push(this.$paths.inSwitchLED);
    },
    onUpload({ name, data }) {
      this.$store.dispatch("profile/setFileName", name);
      this.$store.dispatch("profile/setData", data);
    },
    onSave(type) {
      this.$refs[type].$el.click();
      return;
      if (this.isSignIn) {
        this.$confirm({
          title: this.$t("index.downloadConfirm"),
          onOk: () => {
            this.$refs[type].$el.click();
            api.addLED({
              config_text: JSON.stringify(this.data.lightEffects[4]),
              name: this.fileName,
              description: "",
              is_publish: false,
            });
            api.addLED({
              config_text: JSON.stringify(this.data.lightEffects[5]),
              name: this.fileName,
              description: "",
              is_publish: false,
            });
            api.addLED({
              config_text: JSON.stringify(this.data.lightEffects[6]),
              name: this.fileName,
              description: "",
              is_publish: false,
            });
          },
          width: "8.4rem",
          okText: this.$t("yes"),
          cancelText: this.$t("cancel"),
          centered: true,
        });
      } else {
        this.$refs[type].$el.click();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.isLightScale = false;
      this.isKeyboardScale = true;
    }, 2000);
    setTimeout(() => {
      this.isKeyboardScale = false;
    }, 4000);
  },
};
</script>

<style lang="scss" scoped>
.index {
  min-height: inherit;
  text-align: center;
  color: #ffffff;
  padding: 10px 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .control-panel {
    width: 1200px;
    text-align: left;
    margin: 0 auto 20px auto;
  }

  .cyberboard {
    width: 1200px;
    height: 638px;
    background: no-repeat center center / 100% 100%;
    margin: 0 auto;
    margin-bottom: 40px;
    cursor: pointer;

    .light {
      width: 100%;
      height: 22.5%;
      position: relative;
      animation: 1s light-scale 0.5s ease-out;

      @keyframes light-scale {
        0% {
          transform: scale(1);
          z-index: 1;
        }
        50% {
          transform: scale(1.03);
          z-index: 1;
        }
        100% {
          transform: scale(1);
          z-index: 1;
        }
      }

      img {
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        animation: light-border 4s ease-out infinite;

        &:hover {
          opacity: 1;
        }

        @keyframes light-border {
          0% {
            opacity: 0;
          }
          25% {
            opacity: 1;
          }
          50% {
            opacity: 0;
          }
          100% {
            opacity: 0;
          }
        }
      }
    }

    .keyboard {
      width: 100%;
      height: 77.5%;
      position: relative;
      animation: 1s light-scale 2.5s ease-out;

      @keyframes keyboard-scale {
        0% {
          transform: scale(1);
          z-index: 1;
        }
        50% {
          transform: scale(1.03);
          z-index: 1;
        }
        100% {
          transform: scale(1);
          z-index: 1;
        }
      }

      .c-keyboard {
        width: 100%;
        user-select: none;
      }

      img {
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        animation: keyboard-border 4s ease-out infinite;

        &:hover {
          opacity: 1;
        }

        @keyframes keyboard-border {
          0% {
            opacity: 0;
          }
          50% {
            opacity: 0;
          }
          75% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
      }
    }

    &:hover {
      .light,
      .keyboard {
        img {
          animation: none;
        }
      }
    }
  }

  .buttons {
    @include flex-center;

    .profile {
      @include nowrap;
      width: 140px;
      height: 42px;
      line-height: 42px;
      border: 1px solid $active-color;
      border-right: 0 !important;
      border-radius: 4px 0 0 4px;
      color: $active-color;
      font-size: 12px;
      letter-spacing: 0.2em;
      text-align: left;
      padding: 0 20px;
    }

    .upload {
      @include button;
      width: 180px;
      border-radius: 0 4px 4px 0;
    }

    .download {
      @include button;
      width: 360px;
      margin-left: 100px;
    }
  }

  .in-switch-led {
    position: fixed;
    right: 20px;
    bottom: 200px;
    font-size: 20px;

    .item {
      @include flex-center;
      justify-content: flex-start;
      width: 200px;
      cursor: pointer;

      + .item {
        margin-top: 20px;
      }

      &:hover {
        color: $primary-color;
      }
    }

    i {
      width: 54px;
      height: 54px;
      line-height: 54px;
      display: block;
      background: $primary-color;
      color: #ffffff;
      border-radius: 10px;
      margin-right: 20px;
      font-size: 22px;
      padding-left: 5px;
      text-align: center;
    }
  }
}
</style>
